export default __webpack_public_path__ + "static/media/workshop_01.83038228.jpg";